import type { BetType, RacePageDataTransferObject } from '@mobi/api-types'

export function getAvailableBetTypesFromData(data: RacePageDataTransferObject) {
  return data.AvailableBetTypes.flatMap(betType => {
    if (betType.IsAbandoned) return []

    switch (betType.Type) {
      case 'WinPlace':
        return createBetType('Win & Place', 'WinPlace', data)

      case 'Trifecta':
        return createBetType('Trifecta', 'Trifecta', data)

      case 'Mystery':
        return createBetType('Mystery', 'Mystery', data)

      case 'AllUp':
        return createBetType('All Up', 'AllUp', data)

      case 'Quaddie':
        return createBetType('Quaddie', 'Quaddie', data)

      case 'Double':
        return createBetType('Double', 'Double', data)

      case 'First4':
        return createBetType('First 4', 'First4', data)

      case 'SameRaceMulti':
        return createBetType('Same Race Multi', 'SameRaceMulti', data)

      case 'Exacta':
        return createBetType('Exacta', 'Exacta', data)

      case 'Quinella':
        return createBetType('Quinella', 'Quinella', data)

      default:
        return []
    }
  })
}

// =============
// Local Helpers
// =============

function createBetType(name: string, betType: BetType, data: RacePageDataTransferObject) {
  return [
    {
      name,
      betType,
      hasJackpot: data.AvailablePools.some(
        pool =>
          isPoolForBetType(pool, betType) &&
          isPoolForRaceNumber(pool, data.MeetingInformation.SelectedRace.RaceNumber) &&
          pool.HasJackpot
      ),
    },
  ]
}

function isPoolForBetType(
  pool: RacePageDataTransferObject['AvailablePools'][0],
  betType: BetType
): boolean {
  const lowerCasePoolName = pool.Name.toLowerCase()
  switch (betType) {
    case 'WinPlace':
      return lowerCasePoolName === 'win' || lowerCasePoolName === 'place'

    case 'Quinella':
      return lowerCasePoolName === 'quinella'

    case 'Exacta':
      return lowerCasePoolName === 'exacta'

    case 'Trifecta':
      return lowerCasePoolName === 'trifecta'

    case 'First4':
      return lowerCasePoolName === 'first 4'

    case 'Double':
      return lowerCasePoolName === 'double'

    case 'Quaddie':
      return lowerCasePoolName === 'quaddie'
  }

  return false // mystery, all-up, etc.
}

function isPoolForRaceNumber(
  pool: RacePageDataTransferObject['AvailablePools'][0],
  raceNumber: number
): boolean {
  const hasRaceNumbers = Array.isArray(pool.RaceNumbers) && pool.RaceNumbers.length > 0
  return hasRaceNumbers ? pool.RaceNumbers[0] === raceNumber : true
}
